/**
 * Created by fworld on 2019/9/11.
 */
/**
 * Created by fworld on 2019/6/29.
 */
export default {
  name: 'research',
  path: '/factory/research',
  meta: {title: '研发管理'},
  component: () => import('@/pages/redirect'),
  redirect: {name: 'factory.devices'},
  children: [
    {
      name: 'factory.research.analyze',
      path: 'analyze',
      meta: {title: '异常分析'},
      component: () => import('@/pages/Factory/Research/Analyze'),
    },
    {
      name: 'factory.research.fault',
      path: 'fault',
      meta: {title: '异常库'},
      component: () => import('@/pages/Factory/Research/Faults'),
    },
    {
      name: 'factory.research.version',
      path: 'version',
      meta: {title: '版本库'},
      component: () => import('@/pages/Factory/Research/Version'),
    },
    {
      name: 'factory.research.product',
      path: 'product',
      meta: {title: '产品库'},
      redirect: {name: 'factory.research.product.index'},
      component: () => import('@/pages/redirect'),
      children: [
        {
          path: 'index',
          name: 'factory.research.product.index',
          component: () => import('@/pages/Factory/Research/Product'),
          meta: {
            bg: true,
            break: true,
          }
        }, {
          path: 'detail',
          name: 'factory.research.product.detail',
          component: () => import('@/pages/Factory/Research/Product/detail'),
          meta: {
            bg: true,
            break: false,
          }
        }]

    },
    {
      name: 'factory.research.device',
      path: 'device',
      meta: {title: '设备列表'},
      component: () => import('@/pages/Factory/Research/Device'),
    },
    {
      name: 'factory.research.alarm',
      path: 'alarm',
      meta: {title: '异常告警'},
      component: () => import('@/pages/Factory/Research/Alarm'),
    },

  ]
}
